<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
export default {
  name: "App",
  computed: {
    ...mapGetters([
      "sidebar",
      "avatar",
      "imageUrl",
      "userInfo"
    ]),
  },
  methods: {
  },
  mounted(option) {
    // this.ss();
    // 获取当前页面的URL
    const currentURL = window.location.href;
    //创建一个URL对象来解析当前URL。URL对象提供了方便的属性和方法来处理URL的各个部分
    const url = new URL(currentURL);
    // 使用URLSearchParams获取查询参数
    const queryParams = new URLSearchParams(url.search);
    let token = queryParams.get("token");
    let flag = queryParams.get("flag");
    if (token && flag) {
      this.$store
        .dispatch("user/loginZlj", { token: token, flag: flag })
        .then(() => {
          this.$router.push({ path: "/" });
          // window.location.reload();
        })
        .catch(() => {
          // this.$router.push({ path: "/" });
        });
    }
    // this.voicePrompt('皮卡丘');
  },
};
</script>
<style lang="scss">
::-webkit-scrollbar {
  background-color: transparent;
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-track {
  border-radius: 0;
  background: transparent;
}

.myAge {
  font-size: 20px !important;
}

.line2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
